import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DidoxService } from '../services/fetchServices/didox.service';

export const didoxGuard: CanActivateFn = () => {
  const router = inject(Router);
  const didoxSvc = inject(DidoxService);
  const isLogined = didoxSvc.isAuthorized();
  if (!isLogined) {
    // redirect inside this navigation instead of starting a second one, so the
    // browser's back button doesn't land on the entry we would have pushed
    return router.createUrlTree(['/user-main/didox/auth']);
  }
  return true;
};
